













































import { Component, Vue, Inject} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import ProjectManage from '../projectManage.vue'
@Component({
    name:'qualityManage',
    components: {
        ProjectManage
    }
})
export default class QualityManage extends AbpBase  {
    initData:any ={
        searchData: {
            FundsSource:1
        },
        tableData: {
            title: [
                {
                    title: '项目编号',
                    key: 'projectCode',
                    align: 'center',
                    width: 150
                },
                {
                    title: '项目名称',
                    key: 'projectName',
                    minWidth: 380,
                    align: 'left',
                    render: (h:any,params:any) => {
                        return h('a',{
                            on:{
                                click: ()=> {
                                    this.ToDetail(params.row);
                                }
                            }
                        },params.row.projectName)
                    }
                },
                {
                    title: '工期',
                    key: 'time',
                    align: 'center',
                    width: 170,
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.beginDt.substring(0,7) + '月至' + params.row.endDt.substring(0,7) + '月')
                        ])
                    }
                },
                {
                    title: '完成比例',
                    key: 'achieveRatio',
                    align: 'left',
                    width: 150,
                    render: (h:any, params:any)=>{
                        if(params.row.achieveRatio){
                            return h('div', [
                                h('Progress', {
                                    props: {
                                        percent: params.row.achieveRatio
                                    }
                                })
                            ])
                        }else{
                            return h('div', [
                                h('Progress', {
                                    props: {
                                        percent: 0
                                    }
                                })
                            ])
                        }
                    }
                },
                {
                    title: '月报更新量',
                    key: 'monthCount',
                    align: 'center',
                    width: 100,
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.monthCount ? params.row.monthCount : '0')
                        ])
                    }
                },
                {
                    title: '技术交底',
                    key: 'techCount',
                    align: 'center',
                    width: 90,
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.techCount ? params.row.techCount+'次' : '0次')
                        ])
                    }
                },
                {
                    title: '所（实体）级技术交底情况',
                    key: 'techCount',
                    align: 'center',
                    width: 190,
                    render: (h:any, params:any)=>{
                        console.log(params)
                        return h('Row', [
                            h('Col', {
                                domProps:{
                                    innerHTML:`${params.row.hasDepTech? "已完成":"<p style='color:red;'>未完成</p>"}`
                                }
                            })
                        ])
                    }
                },
                {
                    title: '操作',
                    key: '',
                    align: 'center',
                    width: 250,
                    render: (h:any, params:any)=>{
                        return h('div', [
                            h('Button',{
                                props:{
                                    size:'small'
                                },
                                style:{
                                    marginRight:'5px'
                                },
                                on:{
                                    click:async ()=>{
                                        this.linkTo('QualityTechBasis',params.row.id);
                                    }
                                }
                            },'技术交底'),
                            h('Button',{
                                props:{
                                    size:'small'
                                },
                                style:{
                                    marginRight:'5px'
                                },
                                on:{
                                    click:async ()=>{
                                        this.linkTo('QualityProcess',params.row.id);
                                    }
                                }
                            },'质量检查'),
                            h('Button',{
                                props:{
                                    size:'small'
                                },
                                on:{
                                    click:async ()=>{
                                        this.linkTo('QualityField',params.row.id);
                                    }
                                }
                            },'野外验收')
                        ])
                    }
                }
            ],
            conttent: [],
            totalCount: 0,
            loading: true
        },
        dicData: {
            allDictionary: {},
            bearerOrg: []
        }
    }
    //跳转到技术交底
    linkTo(type:any,id:any){
        (this as any).reloadComponent('projectDetail');
        this.$nextTick( () => {
            this.$router.push({name:'projectDetail',query:{"id":id,'currentName':type}});
        } )
    }
    //项目填报
    Add() {
        (this as any).reloadComponent('projectAdd');
        this.$nextTick( ()=>{
            this.$router.push({
                name: 'projectAdd'
            })
        } )
    }
    //详情
    ToDetail(e:any) {
        (this as any).reloadComponent('projectDetail');
        this.$nextTick( () => {    
            this.$router.push({
                name: 'projectDetail',
                query: {
                    id: e.id
                }
            })
        } )  
    }
    //分页获取数据
    ChangePage(page:any) {
        this.initData.searchData.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchData.MaxResultCount = perPage;
        this.GetData()
    }
    async GetData() {
        this.initData.tableData.loading = true;
        await Ajax.get('/api/services/app/ProjectManager/GetQualityByPageAsync', {params: this.initData.searchData}).then((res:any)=>{
            if(res.data.result){
                this.initData.tableData.content = res.data.result.items;
                this.initData.tableData.totalCount = res.data.result.totalCount;
            }else{
                this.$Message.error('暂无数据！');
                this.initData.tableData.content = [];
                this.initData.tableData.totalCount = 0;
            }
            this.initData.tableData.loading = false;
        })
    }
    async GetDic() {
        if(this.$store.state.project.allDictionary.length == 0){
            await this.$store.dispatch({
                type:'project/GetAllDictionary'
            })
        }   
        if(this.$store.state.project.bearerOrgId.length == 0){
            await this.$store.dispatch({
                type:'project/GetbearerOrg'
            })
        }
        //格式化
        this.$store.state.project.allDictionary.map((item:any) => {
            this.initData.dicData.allDictionary[item.key] = item.items.map((items:any) => {
                return {
                    label: items.displayName,
                    value: items.id
                }
            });
        })
        this.initData.dicData.bearerOrg = this.$store.state.project.bearerOrgId;
    }
    //导出
    Export() {
    	(this as any).$root.Export(this.initData.searchData, '/api/ProjectFile/ExportQualityByPageAsync', '质量管理台账', 'xlsx');
    }
    mounted() {
        this.initData.id = this.$route.query.id;
        this.GetDic();
        this.GetData();
    }
}
